import { useLocation } from "react-router-dom";
import Register from "../../components/Register";
import Seo from "../../components/Seo";
import { REGISTER_SEO_BY_PATH } from "../../constants/seo";

const RegisterPage = () => {
    const location = useLocation();
    const seo = REGISTER_SEO_BY_PATH[location.pathname];

    return (
        <>
            <Seo {...seo} />
            <Register />
        </>
    );
};

export default RegisterPage;
